module.exports = __webpack_public_path__ + "media/notif6.94933f43.wav";